import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './details';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import OtherDetails from './otherDetails';
import Features from './feature';
import ImagesList from './images';
import EscrowAccount from './escrow';
import axios from 'axios';
import { endPoint } from '../../EndPoints/endPoint';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  filePath: '',
  remarks: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const PropertyMasterCreate = ({ onClose, onSaved } = {}) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  let navigate = useNavigate();

  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
  const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
  const [activeFY, setActiveFY] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false]);
  const [loading, setloader] = useState(false);
  const [propertyType, setPropertyType] = useState([]);
  const [ownerShip, setOwnerShip] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [projectUse, setProjectUse] = useState([]);
  const [community, setCommunity] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [propertyCategory, setPropertyCategory] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);

  const validationRules = [
    { key: 'propertyName', message: 'Please Enter Property Name' },
    { key: 'propertyType', message: 'Please Select Property Type' },
    { key: 'category', message: 'Please Select Property Category' },
    { key: 'country', message: 'Please Select Country' },
    { key: 'city', message: 'Please Select City' },
    { key: 'community', message: 'Please Select Community' },
  ];

  const [transectionData, setTransectionData] = useState({
    propertyNo: '',
    propertyName: '',
    plotNo: '',
    plotSize: '',
    remarks: '',
    propertyDescription: '',
    location: '',
    area: '',
    longitude: '',
    latitude: '',
    video: '',
    community: null,
    country: null,
    city: null,
    propertyType: null,
    ownerShip: null,
    projectStatus: null,
    propertyUse: null,
    category: null,
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'PropertyType,ProjectStatus,Country,Community,Ownership,PropertyStatus,PropertyCategory');
      const res = await apiService.getApiParamater('PROPERTY_MULTIDROP', `?${params.toString()}`);
      setPropertyType(res?.data?.dropdowns?.PropertyType);
      setCommunity(res?.data?.dropdowns?.Community);
      setProjectStatus(res?.data?.dropdowns?.ProjectStatus);
      setProjectUse(res?.data?.dropdowns?.PropertyType);
      setOwnerShip(res?.data?.dropdowns?.Ownership);
      setCountries(res?.data?.dropdowns?.Country);
      setPropertyCategory(res?.data?.dropdowns?.PropertyCategory);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    if (onClose) {
      onClose();
      return;
    }
    window.history.back();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      const currentDatetimeUTC = new Date().toISOString();
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      let fullName = transectionData?.firstName + ' ' + transectionData?.lastName;
      const validParam = new URLSearchParams();
      validParam.append('Action', 'CheckPropertyNameExists');
      validParam.append('PropertyName', transectionData?.propertyName);
      const validRes = await apiService.getApiParamater('PROPERTY_COMMON_DATA', `?${validParam.toString()}`);
      const value = Object.values(validRes?.data?.result?.data || {})[0];
      debugger;
      if (value > 0) {
        setloader(false);
        toast.warning('Property with this name already exists');
        return;
      }
      const today = new Date();
      debugger;
      let property = {
        property_No: transectionData?.propertyNo || '0',
        description: transectionData?.propertyName || '0',
        descriptionBI: transectionData?.propertyDescription || '0',
        project: '0',
        location: transectionData?.location || '0',
        address1: '0',
        city: transectionData?.city?.label || '0',
        country: transectionData?.country?.label || '0',
        subDistrict: '0',
        district: '0',
        plot_No: transectionData?.plotNo || '0',
        subPlot_No: '0',
        plot_Size: transectionData?.plotSize || '0',
        community_No: transectionData?.community?.value?.value || '0',
        community_Name: transectionData?.community?.label || '0',
        subCommunity_No: '0',
        subCommunity_Name: '0',
        contact_Person: '0',
        contact_No: '0',
        rate_Sqft: '0',
        developer: '0',
        dContactNo: '0',
        dEmail: '0',
        dContactPerson: '0',
        subDeveloper: '0',
        sdContactNo: '0',
        sdEmail: '0',
        sdContactPerson: '0',
        agent: '0',
        subAgent: '0',
        contractor: '0',
        subContractor: '0',
        total_Units: '0',
        total_Parking: '0',
        floors: '0',
        built_Area: '0',
        gross_Area: transectionData?.area || '0',
        property_Type: transectionData?.propertyType?.label || '0',
        property_Category: transectionData?.category?.label || '0',
        property_Class: transectionData?.ownerShip?.label || '0',
        start_Date: '2026-05-04T17:22:52.606Z',
        end_Date: '2026-05-04T17:22:52.606Z',
        project_Cost: '0',
        project_Status: transectionData?.projectStatus?.label || '0',
        facilities: '0',
        remarks: transectionData?.remarks || '0',
        escrow_Bank: '0',
        escrow_BankAcc: '0',
        latitude: transectionData?.latitude || '0',
        longitude: transectionData?.longitude || '0',
        image_Filename: '0',
        ownerNo: '0',
        ownerName: '0',
        ownerContactNo: '0',
        ownerEmail: '0',
        referredBy: '0',
        referredOn: '2026-05-04T17:22:52.606Z',
        exp1: '0',
        exp2: '0',
        exp3: '0',
        exp4: '0',
        exp5: '0',
        exp6: '0',
        cardNumber: '0',
        bondNumber: '0',
        bondType: '0',
        bondDate: '2026-05-04T17:22:52.606Z',
        exp7: transectionData?.video || '0',
        exp8: '0',
        exp9: '0',
        exp10: '0',
        exp11: '0',
        exp12: '0',
        modifiedBy: '0',
        modifiedOn: today,
        createdBy: '0',
        createdOn: today,
      };
      const body = {
        propertyMain: {
          property: property,
          images: [
            {
              recordId: '0',
              ref_No: '0',
              image_Description: '0',
              image_Filename: '0',
              isDefault: true,
              folder: '0',
              url: '0',
              exp1: '0',
              exp2: '0',
              exp3: '0',
              createdBy: '0',
              createdOn: today,
              modifiedBy: '0',
              modifiedOn: today,
              isTemp: true,
              imagePath: '0',
            },
          ],
          isEdit: true,
        },
      };

      const postRes = await apiService.post('POST_PROPERTY', body);
      if (postRes?.data?.statusCode === 200) {
        if (attachments) {
          handleUpload(postRes?.data?.result?.propertyNo);
        }
        toast.success(postRes?.data?.message);
        setloader(false);
        if (onSaved) {
          onSaved();
        } else {
          navigate('/Customer/Property/Master/Property/listing');
        }
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    if (!validFiles.length) return;

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', ref_No);
    formData.append('fileCategory', 'Images');

    // ✅ DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post(endPoint.UNIT_FILE, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
  };
  return (
    <div className="d-flex flex-column property-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <h5 className="mb-0">{t('propertyMaster.addFormTitle')}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4 property-modal-tabs">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            {t('propertyMaster.tabs.details')}
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            {t('propertyMaster.tabs.images')}
          </div>
        </div>
      </div>
      {/* Lease Details */}
      {gridVisibility[0] && (
        <PersonalDetails
          tableLoading={tableLoading}
          propertyType={propertyType}
          ownerShip={ownerShip}
          setTransectionData={setTransectionData}
          rowData={rowData}
          projectUse={projectUse}
          community={community}
          transectionData={transectionData}
          projectStatus={projectStatus}
          cityList={cityList}
          propertyCategory={propertyCategory}
          countriesList={countriesList}
          setCityList={setCityList}
        />
      )}
      {gridVisibility[3] && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {loading === true ? (
          <div className="mainbtn flex-end gap-2">
            <ClipLoader color="#ffffff" className="mt-1" size={20} />
          </div>
        ) : (
          <div className="mainbtn flex-end gap-2" onClick={handleSave}>
            <FaSave color="#fff" className="center mt-1 mx-2" />
            <div className="center">{t('common.add')}</div>
          </div>
        )}
        <div className="mainbtnRed flex-end gap-2" onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default PropertyMasterCreate;
